module.exports = __webpack_public_path__ + "img/GREEN_YELLOW_120X35.00bc47b7.png";